type Translator = (key: string) => string;

/** 전역 번역 함수 (app.ts에서 한 번만 설정) */
let _t: Translator = (key) => key;

export const setEnumTranslator = (t: Translator) => {
    _t = t;
};

/**
 * 원하는 객체(Enum 라벨 맵)를 다국어 대응 Proxy로 변환합니다.
 *
 * [특징]
 * - 단일 키: 'components.protoWord.indicator.letter' → 번역된 텍스트 반환
 * - 배열 키: ['components.protoWord.indicator.choose1', 'components.protoWord.indicator.choose2'] → 각각 번역 후 합쳐서 반환
 */
export function createI18nProxy<T extends string | number | symbol>(
    keys: Record<T, string | string[]>,
): Record<T, string> {
    return new Proxy(keys, {
        get(target, prop) {
            // Symbol(iterator 등)이나 기본 프로토타입 메서드는 가로채지 않음 (에러 방지)
            if (typeof prop === 'symbol' || prop in Object.prototype) {
                return Reflect.get(target, prop);
            }
            const key = target[prop as unknown as T];
            if (!key) {
                return Reflect.get(target, prop);
            }
            // 배열인 경우 각각 번역 후 합치기
            if (Array.isArray(key)) {
                return key.map((k) => _t(k)).join('');
            }
            // 단일 키인 경우 번역
            return _t(key as string);
        },
        ownKeys(target) {
            return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor(target, prop) {
            return Reflect.getOwnPropertyDescriptor(target, prop);
        },
    }) as Record<T, string>;
}
